import { getFetcher } from "@/services/global";
import { setCookie } from "cookies-next";
import useSWR from "swr";

function useHomeJson(lang, fetchHomeJson) {
  const res = useSWR(
    () => (fetchHomeJson ? `/api/getHomeJson?locale=${lang}` : null),
    getFetcher,
    {
      revalidateOnMount: 30 * 60 * 1000, // 30 minutes in milliseconds
      revalidateOnFocus: false,
      onSuccess: ({data}) => {
       const fastDeliveryIds = data?.at(0)?.['fast-delivery-region-ids']
       console.log('fastDeliveryIds', fastDeliveryIds)
       fastDeliveryIds && setCookie('fdr_ids', fastDeliveryIds?.toString())

       
      },
    }
  );
  return {
    data: res?.data,
    isLoading: !res?.error && !res?.data,
    isError: res?.error,
  };
}

export default useHomeJson;
